import { OPTIONS, OPTIONS_INTEGRATION, SERVICE_ORDER_TYPES } from 'app-constants'
import { http } from 'hooks'

export function contractService() {
  function getContracts() {
    return http.get('/v1/contracts', OPTIONS_INTEGRATION)
  }

  function unlockContracts(idContract) {
    return http.post(`/v1/contracts/unlock/${idContract}`, {}, OPTIONS_INTEGRATION)
  }

  function getIsEligibleToUnlockContract(idContract) {
    return http.get(`/v1/contracts/unlock/${idContract}/eligible`, OPTIONS_INTEGRATION)
  }

  function getContractDetails(id) {
    return http.get(`v1/contracts/detail/${id}`, OPTIONS_INTEGRATION)
  }

  function updateDueDateContract(id, body) {
    return http.put(`v1/contracts/due-date/${id}`, body, OPTIONS_INTEGRATION)
  }

  function getDueDateDays(params) {
    return http.get(`/v1/contracts/due-date`, { ...OPTIONS_INTEGRATION, params })
  }

  function getContractActivationStatus(id) {
    return http.get(`/v1/service-orders/${id}/detail`, {
      ...OPTIONS_INTEGRATION,
      params: {
        serviceOrderType: SERVICE_ORDER_TYPES.ACTIVATION,
      },
    })
  }

  function getTvActivationLink(params) {
    return http.post('/v1/contracts/activate', params, OPTIONS_INTEGRATION)
  }

  function getContractFile(contractId) {
    return http.get(`/v1/contracts/term/${contractId}`, { ...OPTIONS, responseType: 'blob' })
  }

  return {
    getContracts,
    unlockContracts,
    getIsEligibleToUnlockContract,
    getContractDetails,
    updateDueDateContract,
    getDueDateDays,
    getContractActivationStatus,
    getTvActivationLink,
    getContractFile,
  }
}
